const isLocal = window.location.hostname.indexOf("localhost") > -1
const baseUrl = isLocal
  ? "http://localhost:8080"
  : "https://cb-back-end-72563240233.us-east1.run.app"
class API {
  static makeGetRequest = (user, route) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestUrl = `${baseUrl}/api/${route}`
        const token = user && (await user.getIdToken())
        const res = await fetch(requestUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }).then((r) => r.json())
        resolve(res)
      } catch (e) {
        console.error(e)
        reject(e)
      }
    })
  }

  static makePostRequest = (user, route, body) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestUrl = `${baseUrl}/api/${route}`
        const token = user && (await user.getIdToken())
        const rawRes = await fetch(requestUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(body),
          method: "post",
        })

        const res = await rawRes.json()

        if (rawRes.status !== 200) {
          return reject(res.message)
        }

        resolve(res)
      } catch (e) {
        console.error(e)
        reject(e)
      }
    })
  }
}

export default API
